module.exports = __webpack_public_path__ + "media/components/src/assets/images/user_info/img_user-57eaffad476e3d75ed320c4d1fa58d94.svg";